<template>
    <div>
        <div class="splide" id="campaign-pictures" v-if="imageList.length > 1">
            <div class="splide__track">
                <ul class="splide__list">
                    <li class="splide__slide"
                        v-for="(image, k) in imageList"
                        :key="k">
                        <div class="campaign-image" :style="{'background-image': `url('${image.fullImageUrl}')`}"></div>
                    </li>
                </ul>
            </div>
        </div>
        <div v-else>
            <div class="campaign-image" :style="{'background-image': `url('${imageList[0].fullImageUrl}')`}"></div>
        </div>
    </div>
</template>
<script>
import Splide from '@splidejs/splide'; //https://splidejs.com/

export default {
    name: "Picture",
    props: {
        campaign: { type: Object, required: true },
    },
    data: function() {
        return {
            imageList: this.campaign.pictures,
        };
    },
    mounted: function() {
        if (this.imageList.length > 1) {
            new Splide('#campaign-pictures', {
                type: 'loop',
                arrows: false,
            }).mount();
        }
    },
}
</script>
<style lang="scss" scoped>
    @import "../style/base/image.scss";
    .campaign-image {
        border-radius: 10px;
        @include boxRatio($ratio: 66.66%);
    }
</style>
